// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__2wWe9","title":"card_title__2LQnb","inActive":"card_inActive__2Xr5r"};